// ItemUpsellSection — one item-upsell group in ProductOptionView. Each row
// shows "+" until picked, then a quantity stepper. Pick-one groups swap the
// picked item; the "Upsell" (single items) group allows many.
import { PlusOutlined } from '@ant-design/icons';
import { distinctCount } from '../rules';
import GroupBadge from './GroupBadge.jsx';
import OptionPriceDelta from './OptionPriceDelta.jsx';
import QtyStepper from './QtyStepper.jsx';

export default function ItemUpsellSection({ group, selection, onChange, t }) {
  const multi = group.isMultiSelect;
  const hint = multi
    ? t('itemUpsellsHint', 'Add items to go with this')
    : group.required
      ? t('pleaseSelectOne', 'Please select any 1 option')
      : t('optionalPickOne', 'optional · pick one');

  return (
    <section className="po-section">
      <div className="po-section-head">
        <h3 className="po-section-title">{group.name}</h3>
        <GroupBadge
          required={group.required}
          limit={multi ? 0 : 1}
          count={distinctCount(selection)}
          pick={0}
          t={t}
        />
      </div>
      <p className="po-section-sub">{hint}</p>
      <div className="po-row-list">
        {group.items.map((item) => {
          const qty = Number(selection?.[item.id]) || 0;
          return (
            <div key={item.id} className={`po-row is-static ${qty ? 'is-selected' : ''}`}>
              <span className="po-row-text">
                <span className="po-row-name">
                  {item.name}
                  {item.quantity > 1 && ` × ${item.quantity}`}
                </span>
                <OptionPriceDelta amount={item.price} className="po-row-price" />
              </span>
              {qty ? (
                <QtyStepper
                  value={qty}
                  min={0}
                  label={item.name}
                  onChange={(next) => onChange(group, item, next)}
                />
              ) : (
                <button
                  type="button"
                  className="po-row-add"
                  aria-label={`${t('add', 'Add')} ${item.name}`}
                  onClick={() => onChange(group, item, 1)}
                >
                  <PlusOutlined />
                </button>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
